export default __webpack_public_path__ + "19f34a0832e6956445596611aadbb6ec.svg";